import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LoadingScreen } from '@/design/components';
import { useSession } from './useSession';
import { useMe } from './useMe';
import { NoEmployeeRecord } from './NoEmployeeRecord';

/**
 * בלי סשן, לכניסה. יש סשן אבל אין רשומת עובד פעילה (עובד שהושבת):
 * מסך הסבר עם אותו נוסח כמו מספר לא רשום (PRD 2.6).
 */
export function RequireAuth() {
  const { session, isLoading: isSessionLoading } = useSession();
  const { me, isLoading: isMeLoading } = useMe();
  const location = useLocation();

  if (isSessionLoading) return <LoadingScreen />;
  if (!session) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (isMeLoading) return <LoadingScreen />;
  if (!me) return <NoEmployeeRecord />;

  return <Outlet />;
}
